import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Apply from "@/pages/Apply";
import ThankYou from "@/pages/ThankYou";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Fires a Meta Pixel PageView on SPA route changes (the base script in
// index.html already fires the initial PageView, so skip the first render).
function MetaPixelRouteTracker() {
  const { pathname, search } = useLocation();
  const isFirst = useRef(true);
  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [pathname, search]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <MetaPixelRouteTracker />
        <Routes>
          <Route path="/" element={<Apply />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/video" element={<ThankYou />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="*" element={<Apply />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
